import { getAuth } from "firebase/auth"
import { updateDoc } from "firebase/firestore"
import { getUserRef } from "hooks/firestore/getRefs"

export const startSetCurrentRestaurant = async (id: string) => {
  const uid = getAuth()?.currentUser?.uid

  uid && (await updateDoc(getUserRef(uid), { currentRestaurant: id }))
}
